import { ENV } from '../../config/runtimeEnv';
import { Medication } from '../../types/healthcare/MedicationTypes';
import type { UserUuid } from '../../types/identity';
import { http } from '../../lib/http/client';

const BASE = ENV.VITE_HEALTHCARE_SERVER;

export const fetchPatientMedications = async (patientId: UserUuid): Promise<Medication[]> => {
	const res = await http.get(`${BASE}/patient/${patientId}/medications`);
	return res.data.data;
};

export const submitMedicationEscript = async (
	patientId: UserUuid,
	medicationId: number,
	scriptUrl: string,
	notes?: string
): Promise<{ data: Medication; message: string }> => {
	const res = await http.post(
		`${BASE}/patient/${patientId}/medications/${medicationId}/submit-escript`,
		{ script_url: scriptUrl, notes }
	);
	return res.data;
};